/**
 * 学习乐园 · 连连看题材包：动物配食物（lianliankan/pack-shiwulian.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：动物连它吃什么（「猫」连「老鼠」）。note 存一句食性讲解
 * （「捉老鼠的能手」）——配上的那一瞬把「谁吃什么、为什么能吃到」讲一遍。
 * 设计取舍（TODO 存档）：原设想「食物链相邻捕食对」（鹰—蛇、蛇—蛙），
 * 但同一条链的中间物种会同时出现在两对里（蛇既是鹰的猎物又是捕蛙者），
 * 两张「蛇」牌分属不同对，配错反馈没法指对搭档（rel 型按 pair 报 mate）——
 * 按栏目「反馈可解释」红线，改用动物与食物都互不重复的独立对，链的
 * 传递关系留给二组排排序的「食物链排序」去讲。
 * 20 对备 18 对/局，每局组合不同。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.shiwulian = {
    id: 'shiwulian',
    name: '动物配食物',
    hint: '谁吃什么，连上讲习性',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: '猫', r: '老鼠', note: '捉老鼠的能手' },
      { l: '牛', r: '草', note: '反刍慢慢消化青草' },
      { l: '熊猫', r: '竹子', note: '九成食物是竹子' },
      { l: '啄木鸟', r: '树虫', note: '森林医生，敲树找虫' },
      { l: '松鼠', r: '松果', note: '藏松果过冬' },
      { l: '蜜蜂', r: '花蜜', note: '带回蜂巢酿成蜜' },
      { l: '青蛙', r: '蚊子', note: '舌头一卷就捉住' },
      { l: '兔子', r: '胡萝卜', note: '门牙一辈子都在长' },
      { l: '猴子', r: '桃子', note: '灵长类爱吃水果' },
      { l: '老虎', r: '野猪', note: '山林里的伏击手' },
      { l: '企鹅', r: '鱼', note: '不会飞的潜水鸟' },
      { l: '蓝鲸', r: '磷虾', note: '最大的动物吃最小的虾' },
      { l: '蚂蚁', r: '面包屑', note: '扛得动比自己重的食物' },
      { l: '蚕', r: '桑叶', note: '蚕宝宝只吃桑叶' },
      { l: '狗', r: '骨头', note: '啃骨头磨牙' },
      { l: '老鹰', r: '田鼠', note: '高空盘旋，俯冲捕捉' },
      { l: '蜘蛛', r: '苍蝇', note: '结网等蚊蝇自投罗网' },
      { l: '母鸡', r: '谷粒', note: '啄一下吃一口' },
      { l: '燕子', r: '飞虫', note: '边飞边张嘴捕虫' },
      { l: '长颈鹿', r: '树叶', note: '伸长脖子吃高处的叶' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
